import * as React from 'react'

import Modal from 'modules/core/components/Modal'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useUpdateCustomTimeRangeCategory } from 'modules/time_categories_settings/hooks/useUpdateCustomTimeRangeCategory'

import Footer from './Footer'

interface Props {
  categoryId: number
  name: string
  setArchiveModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const ArchiveCategoryModal = ({ categoryId, name, setArchiveModalOpen }: Props) => {
  const { update, loading } = useUpdateCustomTimeRangeCategory()
  const payload = {
    id: categoryId,
    archived: true,
  }

  return (
    <Modal
      illustration="alert"
      title={i18n.t('work_time_categories.modals.archive_title', {
        name,
      })}
      description={i18n.t('work_time_categories.modals.archive_description', {
        name,
      })}
      onClose={() => setArchiveModalOpen(false)}
      onSubmit={async () => {
        const result = await update(payload)
        const handled = handleResult(result, () => undefined)

        if (handled.success) {
          app.setFlash({
            type: 'correct',
            message: i18n.t('common.removed_successfully'),
          })
        }
        setArchiveModalOpen(false)
        return handled
      }}
      footer={<Footer setArchiveModalOpen={setArchiveModalOpen} disableArchive={loading} />}
    ></Modal>
  )
}

export default ArchiveCategoryModal
